import React, { forwardRef, HTMLAttributes } from "react";
import classNames from "classnames";

export type HeaderProps = HTMLAttributes<HTMLDivElement>;

export const Header = forwardRef<HTMLDivElement, HeaderProps>(({ className, children, ...rest }, ref) => {
  return (
    <div {...rest} ref={ref} className={classNames("ui-bottom-sheet-dialog-header", className)}>
      {children}
    </div>
  );
});

Header.displayName = "BottomSheet.Header";
